import React, { useEffect } from 'react';
import './Contact.scss';
import vars from '../vars.scss';
import Snackbar from '@mui/joy/Snackbar';
import axios from 'axios';

export function Contact() {
  const [checkboxRegulations, setCheckboxRegulations] = React.useState(false);
  const [checkboxPrivacy, setCheckboxPrivacy] = React.useState(false);

  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [mobile, setMobile] = React.useState('');
  const [desc, setDesc] = React.useState('');

  const [alertOpen, setAlertOpen] = React.useState(false);

  useEffect(() => {
    const textarea = document.getElementById('descTextArea');

    textarea.addEventListener('input', function () {
      this.style.height = 'auto'; // Reset height to recalculate
      this.style.height = this.scrollHeight + 'px'; // Set new height
      this.style.height =
        Math.max(this.scrollHeight, this.dataset.minHeight) + 'px';
    });
  }, []);

  // const sendContactRequest = async () => {
  //   try {
  //     console.log('just before send _2');
  //     const result = await emailjs.send(
  //       'service_2xx7ico',
  //       'template_tq73o7t',
  //       {
  //         reply_to: email,
  //         from_name: name,
  //         message: desc,
  //       },
  //       'R6CSUrmphpbr-wTtq'
  //     );
  //     console.log('request sent', result);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  const sendEmailResend = async () => {
    try {
      console.log('just before send with axios');
      const response = await axios.post(
        'https://radcaprawnypawlak.pl/contact-request.php',
        {
          message: desc,
          reply_to: email,
          name: name,
          mobile: mobile?.trim() || undefined,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      setAlertOpen(true);
      console.log('Email sent successfully:', response.data);
    } catch (error) {
      console.error('Error sending email:', error);
      throw error;
    }
  };
  const formatPhoneNumber = (value) => {
    // Usunięcie wszystkich znaków poza cyframi i `+` na początku
    let cleaned = value.replace(/\D/g, '');
    if (value.startsWith('+')) {
      cleaned = '+' + cleaned;
    }

    // Dodanie spacji co trzy cyfry
    return cleaned.replace(
      /(\+\d{1,2})?(\d{1,3})?(\d{1,3})?(\d{1,3})?/,
      (match, p1, p2, p3, p4, p5) => {
        return [p1, p2, p3, p4, p5].filter(Boolean).join(' ');
      }
    );
  };

  const handleInputChange = (value) => {
    if (value === '') {
      setMobile('');
      return;
    }
    const formattedNumber = formatPhoneNumber(value);
    setMobile(formattedNumber);
  };

  const isSubmitButtonEnabled = () => {
    const result =
      checkboxPrivacy && checkboxRegulations && !!email && !!name && !!desc;
    return result;
  };
  return (
    <article className="contact-article">
      <Snackbar
        open={alertOpen}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={7000}
        resumeHideDuration={7000}
        color={'success'}
        sx={{
          top: '20px',
          backgroundColor: vars.baseColor,
          borderRadius: '0px',
          fontSize: '14px',
          textAlign: 'center',
          fontFamily: 'Sweet Sans Pro Bold',
        }}
        variant={'solid'}
        onClose={(event, reason) => {
          setAlertOpen(false);
        }}
      >
        <div
          style={{
            width: '100%',
          }}
        >
          Wysłano zapytanie.
          <br /> Wkrótce odpowiem!
        </div>
      </Snackbar>
      <h3>
        serdecznie
        <br />
        zapraszam
      </h3>
      <div className="main-content-text welcome-text">
        <p>r.pr. Magdalena Pawlak</p>
        <p>
          <em>adres do doręczeń:</em>
        </p>
        <p>
          Kancelaria Radcy Prawnego
          <br /> Magdalena Pawlak
          <br />
          ul. Księcia Witolda 38-40/2
          <br />
          50-202 Wrocław
        </p>
        <p>
          Telefon: <a href="tel:531173467">+48 531 173 467</a>
        </p>
        <a
          href={'mailto:kancelaria@radcaprawnypawlak.pl'}
          target={'_blank'}
          className="email"
        >
          kancelaria@radcaprawnypawlak.pl
        </a>
      </div>
      <h3 className={'contact-form-header'}>
        formularz
        <br /> kontaktowy
      </h3>
      <div className="main-content-text">
        <form className="form-container" id={'contact-form-id'}>
          <p>
            <b>Masz pytanie</b> lub potrzebujesz <b>pomocy prawnej</b>?
          </p>
          <p>
            A może chcesz uzyskać <b>wycenę</b> usługi prawnej?{' '}
          </p>
          <p>
            <b>Skontaktuj się ze mną – chętnie pomogę!</b>
          </p>
          <p>Na wiadomości e-mailowe staram się odpowiadać niezwłocznie.</p>
          <p>
            W sprawach dla Państwa pilnych oferuję możliwość konsultacji{' '}
            <b>w tym samym dniu.</b>
          </p>
          <div className="form-inputs">
            <section className="input-content">
              <div className="inputbox">
                <div className="inputbox-content">
                  <label htmlFor="name-input">* Imię i nazwisko</label>
                  <input
                    id="name-input"
                    required
                    autoComplete="off"
                    value={name}
                    type="text"
                    onChange={(e) => setName(e.target.value)}
                  />
                  <span className="underline"></span>
                </div>
              </div>
              <div className="inputbox">
                <div className="inputbox-content">
                  <label htmlFor="mobile-input">Telefon (opcjonalnie)</label>
                  <input
                    id="mobile-input"
                    type="tel"
                    autoComplete="off"
                    value={mobile}
                    inputMode={'tel'}
                    pattern="[+]?[0-9\s]*"
                    onChange={(e) => handleInputChange(e.target.value)}
                  />
                  <span className="underline"></span>
                </div>
              </div>
              <div className="inputbox">
                <div className="inputbox-content">
                  <label htmlFor="email-input">* Twój e-mail</label>
                  <input
                    id="email-input"
                    autoComplete="off"
                    autoCapitalize="off"
                    spellCheck={false}
                    value={email}
                    required={true}
                    type="email"
                    pattern="\S+@\S+(\.\S+)+"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <span className="underline"></span>
                </div>
              </div>
              <div className="textareabox">
                <div className="inputbox-content">
                  <label htmlFor="descTextArea">* Opis sprawy</label>
                  <textarea
                    value={desc}
                    id="descTextArea"
                    required
                    onChange={(event) => setDesc(event.target.value)}
                    name="descTextArea"
                  />
                  <span className="underline"></span>
                </div>
              </div>
              <div className="checkbox-container">
                <input
                  type="checkbox"
                  id="terms"
                  name="terms"
                  checked={checkboxRegulations}
                  required
                  onChange={() => setCheckboxRegulations(!checkboxRegulations)}
                />
                <label className={'terms'} htmlFor={'terms'}>
                  Oświadczam, iż zapoznałem się i akceptuję treść{' '}
                  <a href="/kontakt/regulamin.pdf" target={'_blank'}>
                    Regulaminu
                  </a>
                  .
                </label>
              </div>
              <div className="checkbox-container">
                <input
                  type="checkbox"
                  id="privacy"
                  name="privacy"
                  required
                  checked={checkboxPrivacy}
                  onChange={() => setCheckboxPrivacy(!checkboxPrivacy)}
                />
                <label className={'privacy'} htmlFor={'privacy'}>
                  Wyrażam zgodę na przetwarzanie moich danych osobowych zgodnie
                  z{' '}
                  <a href="/kontakt/polityka-prywatnosci.pdf" target={'_blank'}>
                    Polityką prywatności
                  </a>
                  .
                </label>
              </div>
              <div className="btns">
                <button
                  disabled={false}
                  style={{
                    ...(isSubmitButtonEnabled()
                      ? {}
                      : {
                          backgroundColor: vars.disabled,
                        }),
                  }}
                  className="btn btn-confirm"
                  type="submit"
                  onClick={async (e) => {
                    e.preventDefault();
                    let ele = document.getElementById('contact-form-id');
                    let chk_status = ele.checkValidity();
                    console.log(chk_status);
                    ele.reportValidity();
                    console.log('click');
                    if (chk_status && isSubmitButtonEnabled()) {
                      console.log('submit');
                      await sendEmailResend();
                      setName('');
                      setMobile('');
                      setEmail('');
                      setDesc('');
                      setCheckboxRegulations(false);
                      setCheckboxPrivacy(false);
                    }
                  }}
                >
                  Wyślij
                </button>
              </div>
            </section>
          </div>
        </form>
      </div>
    </article>
  );
}
